import { Spinner } from "@core/components";

export function ViewerContentSkeleton() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner variant="secondary" size="lg" />
    </div>
  );
}
